import React from 'react'
import ImageGallery from 'react-image-gallery';
import facebookSvg from './images/galery/originals/facebook.svg'
import youtubeSvg from './images/galery/originals/youtube.svg'
// import facebookThumbnail from './images/galery/originals/facebookThumbnail.svg'
import youtubeThumbnail from './images/galery/originals/youtubeThumbnail.svg'

// DO NOT EDIT: INCLUDES BEGIN
import img00010600 from "./images/galery/00010600.jpg"
import img00010800 from "./images/galery/00010800.jpg"
import img00011000 from "./images/galery/00011000.jpg"
import img00011600 from "./images/galery/00011600.jpg"

import img00020600 from "./images/galery/00020600.jpg"
import img00020800 from "./images/galery/00020800.jpg"
import img00021000 from "./images/galery/00021000.jpg"
import img00021600 from "./images/galery/00021600.jpg"

import img00030600 from "./images/galery/00030600.jpg"
import img00030800 from "./images/galery/00030800.jpg"
import img00031000 from "./images/galery/00031000.jpg"
import img00031600 from "./images/galery/00031600.jpg"

import img00040600 from "./images/galery/00040600.jpg"
import img00040800 from "./images/galery/00040800.jpg"
import img00041000 from "./images/galery/00041000.jpg"
import img00041600 from "./images/galery/00041600.jpg"

import img00050600 from "./images/galery/00050600.jpg"
import img00050800 from "./images/galery/00050800.jpg"
import img00051000 from "./images/galery/00051000.jpg"
import img00051600 from "./images/galery/00051600.jpg"

import img00060600 from "./images/galery/00060600.jpg"
import img00060800 from "./images/galery/00060800.jpg"
import img00061000 from "./images/galery/00061000.jpg"
import img00061600 from "./images/galery/00061600.jpg"

import img00070600 from "./images/galery/00070600.jpg"
import img00070800 from "./images/galery/00070800.jpg"
import img00071000 from "./images/galery/00071000.jpg"
import img00071600 from "./images/galery/00071600.jpg"

import img00080600 from "./images/galery/00080600.jpg"
import img00080800 from "./images/galery/00080800.jpg"
import img00081000 from "./images/galery/00081000.jpg"
import img00081600 from "./images/galery/00081600.jpg"

import img00090600 from "./images/galery/00090600.jpg"
import img00090800 from "./images/galery/00090800.jpg"
import img00091000 from "./images/galery/00091000.jpg"
import img00091600 from "./images/galery/00091600.jpg"

import img00100600 from "./images/galery/00100600.jpg"
import img00100800 from "./images/galery/00100800.jpg"
import img00101000 from "./images/galery/00101000.jpg"
import img00101600 from "./images/galery/00101600.jpg"

import img00110600 from "./images/galery/00110600.jpg"
import img00110800 from "./images/galery/00110800.jpg"
import img00111000 from "./images/galery/00111000.jpg"
import img00111600 from "./images/galery/00111600.jpg"

import img00120600 from "./images/galery/00120600.jpg"
import img00120800 from "./images/galery/00120800.jpg"
import img00121000 from "./images/galery/00121000.jpg"
import img00121600 from "./images/galery/00121600.jpg"

// DO NOT EDIT: INCLUDES END

class MyImageGallery extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            images: [],
            showVideo: {},
        };

        this.loaded = 0;
        this.firstLoadDone = false;

        // DO NOT EDIT: DEFINES BEGIN
this.images = [
    [img00010600, img00010800, img00011000, img00011600],
    [img00020600, img00020800, img00021000, img00021600],
    [img00030600, img00030800, img00031000, img00031600],
    [img00040600, img00040800, img00041000, img00041600],
    [img00050600, img00050800, img00051000, img00051600],
    [img00060600, img00060800, img00061000, img00061600],
    [img00070600, img00070800, img00071000, img00071600],
    [img00080600, img00080800, img00081000, img00081600],
    [img00090600, img00090800, img00091000, img00091600],
    [img00100600, img00100800, img00101000, img00101600],
    [img00110600, img00110800, img00111000, img00111600],
    [img00120600, img00120800, img00121000, img00121600],
];
        // DO NOT EDIT: DEFINES END

        // Non image content
    }

    _renderYoutube(item) {
        return (
            <div className='video-wrapper'>
                <iframe
                    title={item.title}
                    width='560'
                    height='315'
                    src={item.embedUrl}
                    frameBorder='0'
                    allowFullScreen
                >
                </iframe>
            </div>
        );
    }

    _renderSvg(item) {
        return (
            <a href={item.url}>
                <img src={item.original} style={{ width: "100%" }} alt="Facebook" />
            </a>
        );
    }

    onImageLoad() {
        if (this.firstLoadDone)
            return;

        this.loaded++;
        if (this.loaded >= this.images.length) {
            this.props.onImgLoaded('MyImageGallery');
            this.firstLoadDone = true;
        }
    }

    componentDidMount() {
        let images = [[], [], [], [], []];

        for (let i = 0; i < this.images[0].length; i++) {
            for (let j = 0; j < this.images.length; j++) {
                images[i].push({ original: this.images[j][i], thumbnail: this.images[j][0] });
            }

            images[i].push({
                original: facebookSvg,
                thumbnail: facebookSvg,
                renderItem: this._renderSvg.bind(this),
                url: 'https://www.fb.me/pluspunktmusik'
            });

            images[i].push({
                thumbnail: youtubeThumbnail,
                embedUrl: 'https://www.youtube.com//embed/Wsmc2uHPOCo?showinfo=0',
                title: 'youtubeTest',
                renderItem: this._renderYoutube.bind(this)
            });

            images[i].push({
                thumbnail: youtubeThumbnail,
                embedUrl: 'https://www.youtube.com/embed/XmKwabxi0zg?showinfo=0',
                title: 'youtubeTest',
                renderItem: this._renderYoutube.bind(this)
            });

            images[i].push({
                thumbnail: youtubeThumbnail,
                embedUrl: 'https://www.youtube.com/embed/7mR6oVBM3go?showinfo=0',
                title: 'youtubeTest',
                renderItem: this._renderYoutube.bind(this)
            });

            images[i].push({
                thumbnail: youtubeThumbnail,
                embedUrl: 'https://www.youtube.com/embed/KdWB98wXkoI?showinfo=0',
                title: 'youtubeTest',
                renderItem: this._renderYoutube.bind(this)
            });

            images[i].push({
                original: youtubeSvg,
                thumbnail: youtubeSvg,
                renderItem: this._renderSvg.bind(this),
                url: 'https://www.youtube.com/channel/UCmRi5Md0-RwaygfOCBo1oAA'
            });
        }

        this.setState({
            images: images,
        });
    }

    render() {

        if (!this.state.images || this.state.images.length < 0)
            return null;

        return (
            <ImageGallery
                ref={i => this._imageGallery = i}
                items={this.state.images[this.props.imgResIndex]}
                showThumbnails={true}
                lazyLoad={false}
                showPlayButton={false}
                // onSlide={this._onSlide.bind(this)}
                onImageLoad={this.onImageLoad.bind(this)}
            />
        );
    }
}

export default MyImageGallery;



// WEBPACK FOOTER //
// ./src/MyImageGallery.js